@if (showScrim()) {
  <button type="button" class="nav__scrim nav__scrim--visible" i18n-aria-label aria-label="Close navigation" (click)="onScrimClick()"></button>
}

<nav
  class="nav"
  [class.nav--mobile]="layoutService.isMobileLayout()"
  [class.nav--mobile-open]="isMobileDrawerOpen()"
  [class.nav--panel-open]="isPanelExpanded() && !isCoarsePointer() && !layoutService.isMobileLayout()"
  [class.nav--panel-open-touch]="isPanelExpanded() && isCoarsePointer() && !layoutService.isMobileLayout()"
  [class.nav--expanded]="showExpandedContent() && !isCoarsePointer() && !layoutService.isMobileLayout()"
  [class.nav--touch-expanded]="showExpandedContent() && (isCoarsePointer() || layoutService.isMobileLayout())"
  i18n-aria-label
  aria-label="Main navigation"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (focusin)="onPanelFocusIn()"
  (focusout)="onPanelFocusOut($event)"
  (transitionend)="onPanelTransitionEnd($event)">
  @if (isMobileDrawerOpen()) {
    <div class="nav__mobile-header">
      <span class="nav__mobile-title" i18n>Menu</span>
      <button type="button" class="nav__mobile-close" i18n-aria-label aria-label="Close navigation" (click)="onMobileCloseClick()">
        <i class="fa-regular fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
  }

  <ng-scrollbar class="nav__scroll" orientation="vertical" appearance="compact">
    <ul class="nav__list">
      @for (item of navMenu(); track $index; let index = $index) {
        <li class="nav__item">
          @if (hasSubmenu(item)) {
            <button
              type="button"
              class="nav__row nav__row--parent"
              [class.nav__row--active]="isItemActive(item)"
              [attr.aria-expanded]="isSubmenuOpen(index)"
              [attr.aria-label]="!showExpandedContent() ? item.label : null"
              (click)="onParentClick(index, $event)"
              (keydown)="onParentKeydown(index, $event)">
              @if (isItemActive(item)) {
                <span class="nav__row-indicator" aria-hidden="true"></span>
              }
              <span class="nav__row-icon-slot">
                <span class="nav__row-icon-frame">
                  <span class="nav__row-icon fa-fw" [ngClass]="item.icon ?? ''" aria-hidden="true"></span>
                </span>
              </span>
              <span class="nav__row-label">{{ item.label }}</span>
              <span class="nav__row-caret" [class.nav__row-caret--open]="isSubmenuOpen(index)" aria-hidden="true">
                <i class="fa-solid fa-chevron-right"></i>
              </span>
            </button>

            <div class="nav__submenu" [class.nav__submenu--open]="isSubmenuOpen(index)">
              <div class="nav__submenu-inner">
                <ul class="nav__submenu-list">
                  @for (child of item.items; track $index; let childIndex = $index) {
                    <li class="nav__submenu-item">
                      @if (hasSubmenu(child)) {
                        <button
                          type="button"
                          class="nav__submenu-link nav__submenu-link--parent"
                          [class.nav__submenu-link--active]="isChildActive(child)"
                          [attr.aria-expanded]="isNestedSubmenuOpen(childIndex)"
                          (click)="onNestedParentClick(childIndex, $event)"
                          (keydown)="onNestedParentKeydown(childIndex, $event)">
                          <span class="nav__submenu-icon-slot">
                            <span class="nav__submenu-icon" [ngClass]="child.icon ?? defaultSubmenuIcon" aria-hidden="true"></span>
                          </span>
                          <span class="nav__submenu-label">{{ child.label }}</span>
                          <span class="nav__submenu-caret" [class.nav__submenu-caret--open]="isNestedSubmenuOpen(childIndex)" aria-hidden="true">
                            <i class="fa-solid fa-chevron-right"></i>
                          </span>
                        </button>

                        <div class="nav__submenu nav__submenu--nested" [class.nav__submenu--open]="isNestedSubmenuOpen(childIndex)">
                          <div class="nav__submenu-inner">
                            <ul class="nav__submenu-list">
                              @for (grandchild of child.items; track $index) {
                                <li class="nav__submenu-item">
                                  @if (grandchild.routerLink) {
                                    <a
                                      class="nav__submenu-link"
                                      [class.nav__submenu-link--active]="isChildActive(grandchild)"
                                      [routerLink]="grandchild.routerLink"
                                      (click)="onSubmenuLeafClick()">
                                      <span class="nav__submenu-label">{{ grandchild.label }}</span>
                                    </a>
                                  } @else if (grandchild.url) {
                                    <a
                                      class="nav__submenu-link"
                                      [class.nav__submenu-link--active]="isChildActive(grandchild)"
                                      [href]="grandchild.url"
                                      (click)="onSubmenuLeafClick()">
                                      <span class="nav__submenu-label">{{ grandchild.label }}</span>
                                    </a>
                                  } @else {
                                    <button
                                      type="button"
                                      class="nav__submenu-link"
                                      [class.nav__submenu-link--active]="isChildActive(grandchild)"
                                      (click)="grandchild.command?.({ originalEvent: $event, item: grandchild }); onSubmenuLeafClick()">
                                      <span class="nav__submenu-label">{{ grandchild.label }}</span>
                                    </button>
                                  }
                                </li>
                              }
                            </ul>
                          </div>
                        </div>
                      } @else if (child.routerLink) {
                        <a
                          class="nav__submenu-link"
                          [class.nav__submenu-link--active]="isChildActive(child)"
                          [routerLink]="child.routerLink"
                          (click)="onSubmenuLeafClick()">
                          <span class="nav__submenu-icon-slot">
                            <span class="nav__submenu-icon" [ngClass]="child.icon ?? defaultSubmenuIcon" aria-hidden="true"></span>
                          </span>
                          <span class="nav__submenu-label">{{ child.label }}</span>
                        </a>
                      } @else if (child.url) {
                        <a class="nav__submenu-link" [class.nav__submenu-link--active]="isChildActive(child)" [href]="child.url" (click)="onSubmenuLeafClick()">
                          <span class="nav__submenu-icon-slot">
                            <span class="nav__submenu-icon" [ngClass]="child.icon ?? defaultSubmenuIcon" aria-hidden="true"></span>
                          </span>
                          <span class="nav__submenu-label">{{ child.label }}</span>
                        </a>
                      } @else {
                        <button
                          type="button"
                          class="nav__submenu-link"
                          [class.nav__submenu-link--active]="isChildActive(child)"
                          (click)="child.command?.({ originalEvent: $event, item: child }); onSubmenuLeafClick()">
                          <span class="nav__submenu-icon-slot">
                            <span class="nav__submenu-icon" [ngClass]="child.icon ?? defaultSubmenuIcon" aria-hidden="true"></span>
                          </span>
                          <span class="nav__submenu-label">{{ child.label }}</span>
                        </button>
                      }
                    </li>
                  }
                </ul>
              </div>
            </div>
          } @else if (item.routerLink) {
            <a
              class="nav__row"
              [class.nav__row--active]="isItemActive(item)"
              [routerLink]="item.routerLink"
              [attr.aria-label]="!showExpandedContent() ? item.label : null"
              (click)="onLeafClick()">
              @if (isItemActive(item)) {
                <span class="nav__row-indicator" aria-hidden="true"></span>
              }
              <span class="nav__row-icon-slot">
                <span class="nav__row-icon-frame">
                  <span class="nav__row-icon fa-fw" [ngClass]="item.icon ?? ''" aria-hidden="true"></span>
                </span>
              </span>
              <span class="nav__row-label">{{ item.label }}</span>
            </a>
          } @else if (item.url) {
            <a
              class="nav__row"
              [class.nav__row--active]="isItemActive(item)"
              [href]="item.url"
              [attr.aria-label]="!showExpandedContent() ? item.label : null"
              (click)="onLeafClick()">
              @if (isItemActive(item)) {
                <span class="nav__row-indicator" aria-hidden="true"></span>
              }
              <span class="nav__row-icon-slot">
                <span class="nav__row-icon-frame">
                  <span class="nav__row-icon fa-fw" [ngClass]="item.icon ?? ''" aria-hidden="true"></span>
                </span>
              </span>
              <span class="nav__row-label">{{ item.label }}</span>
            </a>
          } @else {
            <button
              type="button"
              class="nav__row"
              [class.nav__row--active]="isItemActive(item)"
              [attr.aria-label]="!showExpandedContent() ? item.label : null"
              (click)="item.command?.({ originalEvent: $event, item }); onLeafClick()">
              @if (isItemActive(item)) {
                <span class="nav__row-indicator" aria-hidden="true"></span>
              }
              <span class="nav__row-icon-slot">
                <span class="nav__row-icon-frame">
                  <span class="nav__row-icon fa-fw" [ngClass]="item.icon ?? ''" aria-hidden="true"></span>
                </span>
              </span>
              <span class="nav__row-label">{{ item.label }}</span>
            </button>
          }
        </li>
      }
    </ul>
  </ng-scrollbar>

  @if (isMobileDrawerOpen()) {
    <div class="nav__mobile-footer">
      <div class="nav__mobile-account">
        <span class="nav__mobile-avatar" aria-hidden="true">{{ userInitials() }}</span>
        <div class="nav__mobile-account-details">
          <span class="nav__mobile-name">{{ userAccountSummary().displayName }}</span>
          @if (userAccountSummary().email) {
            <span class="nav__mobile-email">{{ userAccountSummary().email }}</span>
          }
        </div>
      </div>

      <div class="nav__mobile-company">
        <i class="fa-duotone fa-solid fa-building nav__mobile-company-icon" aria-hidden="true"></i>
        <span class="nav__mobile-company-name">{{ userAccountSummary().companyName }}</span>
      </div>

      <div class="nav__mobile-actions">
        @if (canSwitchAccount()) {
          <button type="button" class="nav__mobile-action" (click)="onSwitchAccountClick()">
            <i class="fa-duotone fa-solid fa-arrow-right-arrow-left" aria-hidden="true"></i>
            <span i18n>Switch company</span>
          </button>
        }
        <button type="button" class="nav__mobile-action" (click)="onChangePasswordClick()">
          <i class="fa-duotone fa-solid fa-key" aria-hidden="true"></i>
          <span i18n>Change password</span>
        </button>
        <button type="button" class="nav__mobile-action nav__mobile-action--logout" (click)="onLogoutClick()">
          <i class="fa-duotone fa-solid fa-sign-out" aria-hidden="true"></i>
          <span i18n>Log out</span>
        </button>
      </div>
    </div>
  }
</nav>
